(function ($) {
    "use strict";

    // Vendor carousel
    $('.vendor-carousel').owlCarousel({
        loop: true,
        margin: 29,
        nav: false,
        autoplay: true,
        smartSpeed: 1000,
        responsive: {
            0: {
                items: 2
            },
            576: {
                items: 3
            },
            768: {
                items: 4
            },
            992: {
                items: 5
            },
            1200: {
                items: 6
            }
        }
    });

    // Related carousel
    $('.related-carousel').owlCarousel({
        loop: true,
        margin: 29,
        nav: false,
        autoplay: true,
        smartSpeed: 1000,
        responsive: {
            0: {
                items: 1
            },
            576: {
                items: 2
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            }
        }
    });

    // Funkce pro inicializaci Bootstrap 5 karuselu
function initializeBootstrapCarousel() {
    const carousels = document.querySelectorAll('.carousel');
    carousels.forEach(function (carouselElement) {
        const carouselItems = carouselElement.querySelectorAll('.carousel-item');

        // Ujisti se že první item má active třídu
        if (carouselItems.length > 0 && !carouselElement.querySelector('.carousel-item.active')) {
            carouselItems[0].classList.add('active');
        }

        // Skryj controls pokud je jen jeden nebo žádný item
        if (carouselItems.length <= 1) {
            const prevControl = carouselElement.querySelector('.carousel-control-prev');
            const nextControl = carouselElement.querySelector('.carousel-control-next');
            if (prevControl) prevControl.style.display = 'none';
            if (nextControl) nextControl.style.display = 'none';
            return; // Nepokračuj s inicializací
        }

        // Inicializuj Bootstrap 5 Carousel
        const carousel = new window.bootstrap.Carousel(carouselElement, {
            interval: 5000,
            ride: 'carousel'
        });

        // Fallback pro stará Bootstrap 4 tlačítka (data-slide místo data-bs-slide)
        const prevControl = carouselElement.querySelector('.carousel-control-prev[data-slide="prev"]');
        const nextControl = carouselElement.querySelector('.carousel-control-next[data-slide="next"]');

        if (prevControl) {
            prevControl.addEventListener('click', function(e) {
                e.preventDefault();
                carousel.prev();
            });
        }

        if (nextControl) {
            nextControl.addEventListener('click', function(e) {
                e.preventDefault();
                carousel.next();
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initializeBootstrapCarousel();
});

})(jQuery);